
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SearchBar extends Vue {
  @Prop({ default: '' }) value!: string
  @Prop({ default: '搜索' }) placeholder!: string
  @Prop({ default: '100%' }) width!: string | number
  @Prop({ default: 50 }) maxlength!: number | string
  @Prop({ default: false }) showHistory!: boolean
  @Prop({ default: () => [] }) historyList!: string[]
  @Prop({ default: false }) disabled!: boolean
  @Prop({ default: true }) clearable!: boolean

  focused = false
  private blurTimer: number | null = null

  searchIcon = require('@/assets/images/search.png')
  deleteIcon = require('@/assets/images/delete.png')
  closeIcon = require('@/assets/images/close-circle-fill.png')

  get barWidth (): string {
    return typeof this.width === 'number' ? `${this.width}px` : this.width
  }

  get showClear (): boolean {
    return this.clearable && this.focused && !this.disabled && String(this.value || '').length > 0
  }

  onInput (e: Event) {
    const val = (e.target as HTMLInputElement).value
    this.$emit('input', val)
  }

  onFocus () {
    if (this.disabled) return
    if (this.blurTimer !== null) {
      window.clearTimeout(this.blurTimer)
      this.blurTimer = null
    }
    this.focused = true
    this.$emit('focus')
  }

  onBlur () {
    if (this.blurTimer !== null) {
      window.clearTimeout(this.blurTimer)
    }
    this.blurTimer = window.setTimeout(() => {
      this.focused = false
      this.blurTimer = null
      this.$emit('blur')
    }, 180)
  }

  onMaskClick () {
    if (this.blurTimer !== null) {
      window.clearTimeout(this.blurTimer)
      this.blurTimer = null
    }
    this.focused = false
    const input = this.$refs.searchInput as HTMLInputElement | undefined
    input && input.blur()
    this.$emit('blur')
  }

  onSearch () {
    if (this.disabled) return
    this.$emit('search', this.value)
  }

  onClear () {
    if (this.disabled) return
    if (this.blurTimer !== null) {
      window.clearTimeout(this.blurTimer)
      this.blurTimer = null
    }
    this.focused = true
    this.$emit('input', '')
    this.$nextTick(() => {
      const input = this.$refs.searchInput as HTMLInputElement | undefined
      input && input.focus()
    })
  }

  onSelectHistory (item: string) {
    this.$emit('input', item)
    this.$emit('select-history', item)
  }

  onClearHistory () {
    this.$emit('clear-history')
  }

  beforeDestroy () {
    if (this.blurTimer !== null) {
      window.clearTimeout(this.blurTimer)
      this.blurTimer = null
    }
  }
}
